// @flow

import bancoEcofuturo from './banco-ecofuturo.png';
import bancoFassil from './banco-fassil.png';
import bancoProdem from './banco-prodem.png';
import bcp from './bcp.png';
import crecer from './crecer.png';
import eBisa from './e-bisa.png';
import farmacorp from './farmacorp.png';
import laPrimera from './la-primera.png';

type LocationIcon = {
  imgSrc: string,
  altText: string,
}

export function getLocationIcons(): ImmutableArray<LocationIcon> {
  return [
    {
      imgSrc: bancoEcofuturo,
      altText: 'bancoEcofuturo',
    },
    {
      imgSrc: bancoFassil,
      altText: 'bancoFassil',
    },
    {
      imgSrc: bancoProdem,
      altText: 'bancoProdem',
    },
    {
      imgSrc: bcp,
      altText: 'bcp',
    },
    {
      imgSrc: crecer,
      altText: 'crecer',
    },
    {
      imgSrc: eBisa,
      altText: 'eBisa',
    },
    {
      imgSrc: farmacorp,
      altText: 'farmacorp',
    },
    {
      imgSrc: laPrimera,
      altText: 'laPrimera',
    },
  ];
}
